import {
  GoogleMap,
  Marker,
  DirectionsService,
  DirectionsRenderer,
} from "@react-google-maps/api";
import { Modal } from "antd";
import React from "react";

class BookingMap extends React.Component {
  state = {
    directions: null,
  };

  componentDidUpdate(prevProps) {
    const { origin, destination } = this.props;

    if (
      origin &&
      destination &&
      (prevProps.origin !== origin || prevProps.destination !== destination)
    ) {
      const directionsService = new window.google.maps.DirectionsService();
      directionsService.route(
        {
          origin,
          destination,
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === "OK") {
            this.setState({ directions: result });
          } else {
            console.error("Error fetching directions", result);
            Modal.error({
              content: "Error fetching directions",
            });
          }
        }
      );
    }
  }

  render() {
    const { origin, destination } = this.props;

    return (
      <GoogleMap
        mapContainerStyle={{ height: "400px", width: "100%" }}
        center={origin || { lat: 0, lng: 0 }}
        zoom={13}
      >
        {origin && <Marker position={origin} />}
        {destination && <Marker position={destination} />}

        {this.state.directions && (
          <DirectionsRenderer directions={this.state.directions} />
        )}
      </GoogleMap>
    );
  }
}

export default BookingMap;
